import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { EmailComposerModal } from '../../../modules/email/email-composer-modal'
import { EmailLogPage } from '../../../modules/email/email-log-page'

/**
 * `/email` - the sent-mail log + the multi-recipient composer. The Contacts
 * multi-select (PLAN-04) hands off here via `?contactIds=...`; a `compose` flag
 * opens the composer with no preselection. URL is the source of truth.
 */
const emailSearchSchema = z.object({
  contactIds: z.array(z.string()).optional(),
  compose: z.boolean().optional(),
})

export const Route = createFileRoute('/_authed/email/')({
  validateSearch: emailSearchSchema,
  component: EmailRoute,
})

function EmailRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()
  const contactIds = search.contactIds ?? []
  const composerOpen = contactIds.length > 0 || search.compose === true

  const closeComposer = () => navigate({ to: '/email', search: {} })

  return (
    <>
      <EmailLogPage onCompose={() => navigate({ to: '/email', search: { compose: true } })} />
      {composerOpen && <EmailComposerModal contactIds={contactIds} onClose={closeComposer} />}
    </>
  )
}
